import * as actions from './attendanceEntry/actions'
import * as mutations from './attendanceEntry/mutations'
import * as getters from './attendanceEntry/getters'

import { dataProps } from './attendanceEntry/properties'

const state = {
    list: [],
    nav: {
        page_number: 1, had_results: false,
        limit: 10,
        total: 0,
        sort_column_name: 'entry_date',
        sort_direction: 1, 
        search_term: '', 
        search_term_array: []
    },
    props: JSON.parse(JSON.stringify(dataProps)),
}

export default {
    state,
    getters,
    mutations,
    actions
}


// WEBPACK FOOTER //
// ./src/store/modules/attendanceEntry.js